import React from 'react';
import Miniature from '../components/Miniature';
import './GamePage.css';

function GamePage(props) {
  const processedImages = props.images.map((image) =>
    <Miniature src={image}/>
  );

  return (
    <>
      <div>
        <h1>{props.name}</h1>
        <p>{props.description}</p>
        <div className="miniatures-container">
          <div className="miniatures-wrapper">
            <ul className="miniatures-list">
              {processedImages}
            </ul>
          </div>
        </div>
        <p>{props.conclusion}</p>
      </div>
    </>
  )
}

export default GamePage;
